import React, { useEffect, useState } from 'react'
import axios from 'axios'
import MyQrcode from '../../../components/general/qrcode'
import EditFormStatus from './editFormStatus'

export default function AssessmentConfig() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [assessmentConfig, setAssessmentConfig] = useState({})
  const [propsData, setPropsData] = useState({})
  const [isAccessAddressVisible, setIsAccessAddressVisible] = useState(false)
  const [isEditFormStatusVisible, setIsEditFormStatusVisible] = useState(false)

  const getAssessmentConfig = () => {
    axios.post('/p/assessment/config/get', {
      merchant_oid: merchantOid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setAssessmentConfig(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAssessmentConfig()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid])

  const previewAccessAddress = (oid) => {
    setIsAccessAddressVisible(true)
    setPropsData({ accessAddress: 'https://assessment.yunzhaosoft.com/' + merchantOid})
  }

  const editFormStatus = () => {
    setIsEditFormStatusVisible(true)
    setPropsData({ form_status: assessmentConfig.form_status })
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">配置信息</div>
        </div>

        <div className='public-main-style'>
          <div className='public-main-style4'>
            <div className='public-main-style4-items'>
              <div className='public-main-style4-item'>
                <div className='public-main-style4-item-left'>
                  <div className='public-main-style4-item-title'>学生访问地址</div>
                  <div className='public-main-style4-item-description'>点击查看可复制访问链接和下载二维码，可在微信小程序或公众号跳转访问</div>
                </div>
                <div className='public-main-style4-item-right'>
                  <div className='public-main-style4-item-buttonPrimary' onClick={previewAccessAddress}>查看</div>
                </div>
              </div>
            </div>
          

            <div className='public-main-style4-items'>
              <div className='public-main-style4-item'>
                <div className='public-main-style4-item-left'>
                  <div className='public-main-style4-item-title'>用户信息表单收集状态</div>
                  <div className='public-main-style4-item-description'>{assessmentConfig.form_status_name}</div>
                </div>
                <div className='public-main-style4-item-right'>
                  <div className='public-main-style4-item-buttonPrimary' onClick={editFormStatus}>编辑</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isAccessAddressVisible && <MyQrcode
        data={propsData}
        isOpen={isAccessAddressVisible}
        isCancel={() => { setIsAccessAddressVisible(false) }}
      />}

      {isEditFormStatusVisible && <EditFormStatus
        data={propsData}
        getAssessmentConfig={getAssessmentConfig}
        isOpen={isEditFormStatusVisible}
        isCancel={() => { setIsEditFormStatusVisible(false) }}
      />}
    </div>
  )
}
